package com.appsyde.shared.modules.ticket.domain.usecase

import com.appsyde.shared.modules.ticket.domain.model.RenewLockResult
import com.appsyde.shared.modules.ticket.domain.repository.TicketsRepository

class RenewLockUseCase(
    private val repo: TicketsRepository
) {
    suspend operator fun invoke(ticketId: String): RenewLockResult = repo.renewLock(ticketId)
}
